import React, { ReactElement } from 'react';

import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';
import { COACH_LIST_COLUMN, CoachListColumn } from '../NgzCoachList.settings';
import { useUserRoleLabel } from '../../../../shared/hooks/useUserRoleLabel';

type TitleRowProps = {
  visibleColumns: CoachListColumn[];
};

const TitleRow = observer(({ visibleColumns }: TitleRowProps) => {
  const { getForAgent } = useUserRoleLabel();

  const renderColumnsInfo: Record<CoachListColumn, ReactElement> = {
    [COACH_LIST_COLUMN.NAME]: <GridTableCell>Name</GridTableCell>,
    [COACH_LIST_COLUMN.ENTITY]: <GridTableCell>Entity</GridTableCell>,
    [COACH_LIST_COLUMN.STATE]: <GridTableCell>Entity State</GridTableCell>,
    [COACH_LIST_COLUMN.CITY]: <GridTableCell>Entity City</GridTableCell>,
    [COACH_LIST_COLUMN.SETUP_COMMISSION]: <GridTableCell>Setup Comsn</GridTableCell>,
    [COACH_LIST_COLUMN.RENEW_COMMISSION]: <GridTableCell>Renew Comsn</GridTableCell>,
    [COACH_LIST_COLUMN.COACH_DESIGNATION]: (
      <GridTableCell>{getForAgent()} Designation</GridTableCell>
    ),
    [COACH_LIST_COLUMN.STATUS]: <GridTableCell>Status</GridTableCell>,
    [COACH_LIST_COLUMN.EXTRA_INFO]: <div />,
  };

  return (
    <GridTableRow variant="header">
      {visibleColumns.map((col) => (
        <React.Fragment key={col}>{renderColumnsInfo[col]}</React.Fragment>
      ))}
    </GridTableRow>
  );
});

export { TitleRow };
